<template>
   <div
      class="woven-strip size-small wobble"
      :class="loading ? 'animating' : ''"
    >
      <div class="bar"></div>
      <div class="bar"></div>
      <div class="bar"></div>
      <div class="bar"></div>
    </div>
</template>
<script>
export default {
  name: "WovenStrip",
  props: {
    loading: Boolean,
  },
};
</script>
<style lang="scss" scoped>
  .woven-strip {
    position: absolute;
    bottom: 0;
    height: 7px;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    overflow: hidden;
    background-color: rgba(0, 0, 0, 0.1);
  }

  /* SIZE OPTIONS */
  .woven-strip.size-small {
    height: 4px;
  }
  .woven-strip.size-large {
    height: 6px;
  }

  /* REMOVE MAIN BACKGROUND */
  .woven-strip.no-bg {
    background-color: transparent;
  }

  .woven-strip .bar {
    height: 100%;
  }
  .woven-strip .bar:nth-child(1) {
    width: 32.5%;
    background-color: #79242f;
  }
  .woven-strip .bar:nth-child(2) {
    width: 15%;
    background-color: #e00b5b;
  }
  .woven-strip .bar:nth-child(3) {
    width: 40%;
    background-color: #fbda57;
  }
  .woven-strip .bar:nth-child(4) {
    width: 12.5%;
    background-color: #bceae3;
  }

  /* WOBBLE ANIMATION */
  .woven-strip.wobble.animating .bar {
    animation-duration: 1s;
    animation-timing-function: ease-in-out;
    animation-iteration-count: infinite;
  }
  .woven-strip.wobble.animating .bar:nth-child(1) {
    animation-name: burberry-first;
  }
  .woven-strip.wobble.animating .bar:nth-child(2) {
    animation-name: burberry-second;
  }
  .woven-strip.wobble.animating .bar:nth-child(3) {
    animation-name: burberry-third;
  }
  .woven-strip.wobble.animating .bar:nth-child(4) {
    animation-name: burberry-fourth;
  }
  .woven-strip.linear .bar {
    height: 100%;
    width: 0;
  }

  /* LINEAR ANIMATION */
  .woven-strip.linear.animating .bar {
    animation-timing-function: ease-in;
    animation-fill-mode: forwards;
  }
  .woven-strip.linear.animating .bar:nth-child(1) {
    animation-duration: 1s;
    animation-name: linear-first;
    animation-delay: 0s;
  }
  .woven-strip.linear.animating .bar:nth-child(2) {
    animation-duration: 0.8s;
    animation-name: linear-second;
    animation-delay: 1s;
  }
  .woven-strip.linear.animating .bar:nth-child(3) {
    animation-duration: 1.2s;
    animation-name: linear-third;
    animation-delay: 1.8s;
  }
  .woven-strip.linear.animating .bar:nth-child(4) {
    animation-duration: 0.6s;
    animation-name: linear-fourth;
    animation-delay: 3.2s;
  }

  /* KEYFRAMES */
  @keyframes burberry-first {
    25% {
      width: 15%;
    }
    50% {
      width: 40%;
    }
    75% {
      width: 12.5%;
    }
    100% {
      width: 32.5%;
    }
  }
  @keyframes burberry-second {
    25% {
      width: 40%;
    }
    50% {
      width: 12.5%;
    }
    75% {
      width: 32.5%;
    }
    100% {
      width: 15%;
    }
  }
  @keyframes burberry-third {
    25% {
      width: 12.5%;
    }
    50% {
      width: 32.5%;
    }
    75% {
      width: 15%;
    }
    100% {
      width: 40%;
    }
  }
  @keyframes burberry-fourth {
    25% {
      width: 32.5%;
    }
    50% {
      width: 15%;
    }
    75% {
      width: 40%;
    }
    100% {
      width: 12.5%;
    }
  }
  @keyframes linear-first {
    from {
      width: 0%;
    }
    to {
      width: 32.5%;
    }
  }
  @keyframes linear-second {
    from {
      width: 0%;
    }
    to {
      width: 15%;
    }
  }
  @keyframes linear-third {
    from {
      width: 0%;
    }
    to {
      width: 40%;
    }
  }
  @keyframes linear-fourth {
    from {
      width: 0%;
    }
    to {
      width: 12.5%;
    }
  }
</style>
